
































































































import { Vue, Component } from 'vue-property-decorator'
import type { ImagensProduto } from '@/models'

@Component
export default class DialogoDeAdicionarImagemAoProduto extends Vue {
	mostra = false
	imagensLocal: ImagensProduto[] = []
	indicePadrao: number | null = null
	erroPadrao = false
	dragIndex = -1
	dragOverIndex = -1
	errosSequencia: Record<number, string> = {}

	mostrar(imagens: ImagensProduto[] | null) {
		const copia = (imagens ?? []).map(img => ({ ...img }))
		const todasZeradas = copia.every(img => !img.sequencia)
		if (todasZeradas) {
			copia.forEach((img, i) => { img.sequencia = i + 1 })
		} else {
			copia.sort((a, b) => (a.sequencia ?? 0) - (b.sequencia ?? 0))
		}
		this.imagensLocal = copia
		const indexPadrao = copia.findIndex(img => img.padrao)
		this.indicePadrao = indexPadrao !== -1 ? indexPadrao : null
		this.erroPadrao = false
		this.mostra = true
	}

	esconder() {
		this.mostra = false
	}

	adicionarImagem() {
		const proxima = this.imagensLocal.length + 1
		this.imagensLocal.push({ id: '', imagemUrl: '', padrao: false, sequencia: proxima })
	}

	editarSequencia(index: number, valor: string) {
		const nova = parseInt(valor, 10)
		const max = this.imagensLocal.length
		if (isNaN(nova) || nova < 1) {
			this.$set(this.errosSequencia, index, `Mínimo: 1`)
			this.$set(this.imagensLocal[index], 'sequencia', index + 1)
			return
		}
		if (nova > max) {
			this.$set(this.errosSequencia, index, `Máximo: ${max}`)
			this.$set(this.imagensLocal[index], 'sequencia', index + 1)
			return
		}
		this.$delete(this.errosSequencia, index)
		const destino = nova - 1
		if (destino === index) return
		const item = this.imagensLocal.splice(index, 1)[0]
		this.imagensLocal.splice(destino, 0, item)
		if (this.indicePadrao === index) {
			this.indicePadrao = destino
		} else if (index < destino && this.indicePadrao !== null && this.indicePadrao > index && this.indicePadrao <= destino) {
			this.indicePadrao--
		} else if (index > destino && this.indicePadrao !== null && this.indicePadrao >= destino && this.indicePadrao < index) {
			this.indicePadrao++
		}
		this.normalizarSequencias()
		this.errosSequencia = {}
	}

	onDragStart(event: DragEvent, index: number) {
		this.dragIndex = index
		if (event.dataTransfer) event.dataTransfer.effectAllowed = 'move'
	}

	onDragOver(event: DragEvent, index: number) {
		event.preventDefault()
		if (event.dataTransfer) event.dataTransfer.dropEffect = 'move'
		this.dragOverIndex = index
	}

	onDrop(index: number) {
		const from = this.dragIndex
		if (from === -1 || from === index) {
			this.dragIndex = -1
			this.dragOverIndex = -1
			return
		}
		const item = this.imagensLocal.splice(from, 1)[0]
		this.imagensLocal.splice(index, 0, item)
		if (this.indicePadrao === from) {
			this.indicePadrao = index
		} else if (from < index && this.indicePadrao !== null && this.indicePadrao > from && this.indicePadrao <= index) {
			this.indicePadrao--
		} else if (from > index && this.indicePadrao !== null && this.indicePadrao >= index && this.indicePadrao < from) {
			this.indicePadrao++
		}
		this.normalizarSequencias()
		this.dragIndex = -1
		this.dragOverIndex = -1
	}

	onDragEnd() {
		this.dragIndex = -1
		this.dragOverIndex = -1
	}

	remover(index: number) {
		this.imagensLocal.splice(index, 1)
		this.normalizarSequencias()
		if (this.indicePadrao === index) {
			this.indicePadrao = null
		} else if (this.indicePadrao !== null && this.indicePadrao > index) {
			this.indicePadrao--
		}
	}

	normalizarSequencias() {
		this.imagensLocal.forEach((img, i) => { img.sequencia = i + 1 })
	}

	salvar() {
		if (Object.keys(this.errosSequencia).length > 0) return
		if (this.imagensLocal.length > 0 && this.indicePadrao === null) {
			this.erroPadrao = true
			return
		}
		this.erroPadrao = false
		const imagens = this.imagensLocal.map((img, index) => ({
			...img,
			sequencia: img.sequencia ?? index + 1,
			padrao: index === this.indicePadrao,
		}))
		this.$emit('salvar', imagens)
		this.mostra = false
	}
}
